<div class="credential-modal" *transloco="let t; prefix: 'driverInformation.credentials'">
  <div class="credential-modal__header">
    <span class="credential-modal__title">{{ t(hasLoginAccount ? 'title' : 'generate') }}</span>
    <button class="credential-modal__close" type="button" [attr.aria-label]="'common.close' | transloco" [title]="'common.close' | transloco" (click)="close()">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.1959 6.34399L11.9529 10.586L7.71087 6.34399L6.29688 7.75799L10.5389 12L6.29688 16.242L7.71087 17.656L11.9529 13.414L16.1959 17.656L17.6099 16.242L13.3679 12L17.6099 7.75799L16.1959 6.34399Z" fill="#9FA1A4"/>
      </svg>
    </button>
  </div>

  <div class="credential-modal__body">
    @if (isLoading) {
      <div class="credential-modal__loading">
        <span class="spinner-border"></span>
      </div>
    }

    @if (!isLoading && credential) {
      <div class="credential-modal__field">
        <label class="credential-modal__label">{{ 'common.username' | transloco }}</label>
        <input class="form-control credential-modal__input" type="text" [value]="credential.username" readonly>
      </div>

      <div class="credential-modal__field">
        <label class="credential-modal__label">{{ 'common.password' | transloco }}</label>
        <input class="form-control credential-modal__input" [type]="passwordRevealed ? 'text' : 'password'"
          [value]="passwordRevealed ? credential.password : '••••••••'" readonly>
      </div>

      @if (hasLoginAccount && !passwordRevealed) {
        <button class="btn btn-primary credential-modal__reset" type="button"
          [disabled]="isResetting" (click)="resetPassword()">
          @if (isResetting) {
            <span class="spinner-border spinner-border-sm"></span>
          } @else {
            <span><i class="ph ph-arrows-clockwise"></i></span>
          }
          <span>{{ t('resetPassword') }}</span>
        </button>
      }

      @if (passwordRevealed) {
        <div class="credential-modal__actions">
          <button class="btn btn-primary credential-modal__action" type="button" (click)="copyPassword()">
            <i class="ph ph-copy"></i>
            {{ t('copyPassword') }}
          </button>
          <button class="btn btn-outline-primary credential-modal__action" type="button" (click)="downloadCredentials()">
            <i class="ph ph-download-simple"></i>
            {{ t('downloadCredentials') }}
          </button>
        </div>
      }
    }
  </div>
</div>
